import { ActionTree } from 'vuex'

import {
  fetchBookingsFromBeginningOfMonth,
  fetchPastBookings,
} from '@/sdk/clients/BookingsClient'
import { RootState } from '@/store/types'

import { Booking, BookingsState, Mutations } from './types'

const actions: ActionTree<BookingsState, RootState> = {
  async fetchUpcomingBookings({ commit }) {
    const bookingsList: Booking[] = await fetchBookingsFromBeginningOfMonth()

    commit(Mutations.SET_UPCOMING_BOOKINGS, bookingsList)
    commit(Mutations.SET_NO_UPCOMING_BOOKINGS, !bookingsList.length)
  },

  async fetchPastBookings({ commit }) {
    const bookingsList: Booking[] = await fetchPastBookings()

    commit(Mutations.SET_PAST_BOOKINGS, bookingsList)
    commit(Mutations.SET_NO_PAST_BOOKINGS, !bookingsList.length)
  },
}

export default actions
